import ReactGA from 'react-ga4';

import { usePortfolioContext } from '~/hooks';
import PortfolioSummaryTable from './components/PortfolioSummaryTable';
import { DealStates } from '~/constants';
import { usePermissions } from '~/requests/permissions/usePermissions';
import PortfolioSummary from './components/PortfolioSummary';

export default function PortfolioReview() {
  const { portfolio, portfolioState } = usePortfolioContext();
  const { permissions } = usePermissions();

  const isInvestor = !permissions.isAdmin && permissions.hasPortfolioInvestorAccess;
  const showPortfolioSummary = (isInvestor && portfolioState?.latestState >= DealStates.AWAITING_BID) || portfolioState?.latestState >= DealStates.PROJECT_HAS_ERRORS;

  ReactGA.send({
    hitType: 'pageview',
    page: '/portfolio/id/review',
    title: `${portfolio?.name} | Conductor Solar`
  });
  document.title = `${portfolio?.name} | Conductor Solar`;

  return (
    <div>

      <PortfolioSummary />

      {showPortfolioSummary && (
        <div className="card">
          <PortfolioSummaryTable />
        </div>
      )}

    </div>
  );
}

